import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { promises } from 'dns';
import { environment } from '../../../environments/environment';
import * as _ from "lodash";
import { BehaviorSubject, Observable, Subject, Subscription} from 'rxjs';
import * as moment from 'moment';
import { switchMap } from 'rxjs/operators';
declare const $: any;

const TOKEN_KEY = 'auth-token';
const USER_KEY = 'auth-user';
const USER_PERMISSION_LEVEL = 'user-permission-level';
@Injectable({
    providedIn: 'root'
})
export class CommonAPIService {

    USER_ADMIN = 'Admin';
    USER_CSD = 'Collegiate Program Coordinator';
    USER_OM = 'Operations Manager';
    USER_SP = 'Sales Partner';
    USER_SELLER = 'Seller'; // Seller and Sales Partner both are same
    USER_DP = 'Design Partner';
    USER_PP = 'Production Partner';
    USER_NOT_AUTHORIZED = 'Not Authorized';
    SCREEN_PRINTING = 'Screen Printing';
    DIRECT_TO_GARMENT_PRINTING = 'Direct to Garment';
    EMBROIDERY_PRINTING = 'Embroidery';
    VINYL_PRINTING = 'Vinyl';
    FINISHINGS = 'Finishings';
    SHIPPING_METHOD = ['Individual','Bulk'];
    BULK_SHIPPING = 'Bulk';
    INDIVIDUAL_SHIPPING = 'Individual';
    allSearchTypesMasters: any;

    savePricingFunction: BehaviorSubject<any> = new BehaviorSubject(null);
    currentProductionPartner: BehaviorSubject<any> = new BehaviorSubject(null);
    isPrintMethodTabChange: BehaviorSubject<any> = new BehaviorSubject(null);
    getVinylData: BehaviorSubject<any> = new BehaviorSubject(false);
    isOrderCanceled: BehaviorSubject<any> = new BehaviorSubject(false);

    searchCall = new Subject();
    searchResult = new Subject();
    searchAdminCSDUsersCall = new Subject();
    searchAdminCSDUsersResult = new Subject();
    searchSPUsersCall = new Subject();
    searchSPUsersResult = new Subject();
    // checkSaveOrderCall = new Subject();
    // checkSaveOrderResponse = new Subject();
    // saveOrderCall = new Subject();
    // saveOrderResponse = new Subject();
    // getCurrentDateTimeCall = new Subject();
    // getCurrentDateTimeResponse = new Subject();
    checkSaveOrder:Subscription;
    saveOrder :Subscription;
    getCurrentDateTime : Subscription;

    constructor(
        private http: HttpClient
    ) { 
        this.searchCall.pipe(
            switchMap((requestParams:any)=>{
                // console.log('getting request params',requestParams);
                return  this.http.post(requestParams.postUrl, requestParams.requestData, {headers : requestParams.requestHeaders})
            })
        )
        .subscribe((response)=>{
            this.searchResult.next(response)
        },
        (error)=>{
            console.log('error');
        })

        this.searchAdminCSDUsersCall.pipe(
            switchMap((requestParams:any)=>{
                // console.log('getting request params',requestParams);
                return  this.http.post(requestParams.postUrl, requestParams.requestData, {headers : requestParams.requestHeaders})
            })
        )
        .subscribe((response)=>{
            this.searchAdminCSDUsersResult.next(response)
        },
        (error)=>{
            console.log('error');
        })

        this.searchSPUsersCall.pipe(
            switchMap((requestParams:any)=>{
                // console.log('getting request params',requestParams);
                return  this.http.post(requestParams.postUrl, requestParams.requestData, {headers : requestParams.requestHeaders})
            })
        )
        .subscribe((response)=>{
            this.searchSPUsersResult.next(response)
        },
        (error)=>{
            console.log('error');
        })

        // this.checkSaveOrderCall.pipe(
        //     switchMap((requestParams:any)=>{
        //         // console.log('getting request params',requestParams);
        //         return  this.http.post(requestParams.postUrl, requestParams.requestData, {headers : requestParams.requestHeaders})
        //     })
        // )
        // .subscribe((response)=>{
        //     this.checkSaveOrderResponse.next(response)
        // },
        // (error)=>{
        //     console.log('error');
        // })

        // this.saveOrderCall.pipe(
        //     switchMap((requestParams:any)=>{
        //         // console.log('getting request params',requestParams);
        //         return  this.http.post(requestParams.postUrl, requestParams.requestData, {headers : requestParams.requestHeaders})
        //     })
        // )
        // .subscribe((response)=>{
        //     this.saveOrderResponse.next(response)
        // },
        // (error)=>{
        //     console.log('error');
        // })

        // this.getCurrentDateTimeCall.pipe(
        //     switchMap((requestParams:any)=>{
        //         // console.log('getting request params',requestParams);
        //         return  this.http.post(requestParams.postUrl, requestParams.requestData, {headers : requestParams.requestHeaders})
        //     })
        // )
        // .subscribe((response)=>{
        //     this.getCurrentDateTimeResponse.next(response)
        // },
        // (error)=>{
        //     console.log('error');
        // })
    }

    fnHttpPostCallWithObservable(targetUrl, postUrl, requestParameters:any, appendHeaderKey = '', appendHeaderValue = '') : Observable<any>{
        let authToken = this.fnGetAuthToken();
        let headers = new HttpHeaders({
            'Target-URL': targetUrl,
            'Access-Control-Allow-Origin': '*',
            'Access-Token': environment.config.api_key
        });
        if (authToken && authToken.length > 0) {
            headers = headers.append('Auth-Token', authToken);
        }
        if (appendHeaderKey != '' && appendHeaderValue != '') {
            headers = headers.append(appendHeaderKey, appendHeaderValue);
        }
        if (appendHeaderKey=="Content-Type") {
            headers = headers.append("Content-Type", appendHeaderValue);
                    
        }else{
            headers = headers.append("Content-Type",'application/json');
        }

        return this.http.post<any>(postUrl,requestParameters, { headers: headers });
    }

    fnHttpPostCall(targetUrl, postUrl, requestParameters:any, appendHeaderKey = '', appendHeaderValue = '') {
        try {
            return new Promise(async (resolve, reject) => {
                let authToken = this.fnGetAuthToken();
                let headers = new HttpHeaders({
                    'Target-URL': targetUrl,
                    'Access-Control-Allow-Origin': '*',
                    'Access-Token': environment.config.api_key
                });
                if (authToken && authToken.length > 0) {
                    headers = headers.append('Auth-Token', authToken);
                }
                if (appendHeaderKey != '' && appendHeaderValue != '') {
                    headers = headers.append(appendHeaderKey, appendHeaderValue);
                }
                if (appendHeaderKey=="Content-Type") {
                    headers = headers.append("Content-Type", appendHeaderValue);
                    
                }else{
                    headers = headers.append("Content-Type",'application/json');
                }

                this.http.post(postUrl,requestParameters, { headers: headers }).subscribe((data: any) => {

                    resolve(data);
                }, err => {
                    console.error(err);
                    reject(err);
                });
            });
        } catch (error) {
            console.log(error);
        }
    }

    fnFetchHttpRequesHeaders(targetUrl, appendHeaderKey = '', appendHeaderValue = ''){
        let authToken = this.fnGetAuthToken();
        let headers = new HttpHeaders({
            'Target-URL': targetUrl,
            'Access-Control-Allow-Origin': '*',
            'Access-Token': environment.config.api_key
        });
        if (authToken && authToken.length > 0) {
            headers = headers.append('Auth-Token', authToken);
        }
        if (appendHeaderKey != '' && appendHeaderValue != '') {
            headers = headers.append(appendHeaderKey, appendHeaderValue);
        }
        if (appendHeaderKey=="Content-Type") {
            headers = headers.append("Content-Type", appendHeaderValue);
                    
        }else{
            headers = headers.append("Content-Type",'application/json');
        }
        return headers;
    }

    fnFormDataHttpPostCall(targetUrl, postUrl, requestParameters, appendHeaderKey = '', appendHeaderValue = '') {
        try {
            return new Promise(async (resolve, reject) => {
                let authToken = this.fnGetAuthToken();
                let headers = new HttpHeaders({
                    // "Content-Type":"multipart/form-data",
                    'Target-URL': targetUrl,
                    'Access-Control-Allow-Origin': '*',
                    'Access-Token': environment.config.api_key
                });
                if (authToken && authToken.length > 0) {
                    headers = headers.append('Auth-Token', authToken);
                }
                if (appendHeaderKey != '' && appendHeaderValue != '') {
                    headers = headers.append(appendHeaderKey, appendHeaderValue);
                }

                this.http.post(postUrl, requestParameters, { headers: headers }).subscribe((data: any) => {
                    resolve(data);
                }, err => {
                    console.error(err);
                    reject(err);
                });
            });
        } catch (error) {
            console.log(error);
        }
    }
    fnGetAllUsers() {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getAllUsers';
                let requestParameters = {};
                let result = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            })
        } catch (err) {
            console.log(err);
        }
    }

    fngetPermissionLevel() {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getPermissionLevel';
                let requestParameters = {};
                let result = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            })
        } catch (err) {
            console.log(err);
        }
    }

    fnupdateEmailId(user_email,user_id) {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'updateEmailId';
                let requestParameters = {'email': user_email,'user_id':user_id };
                let result = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            })
        } catch (err) {
            console.log(err);
        }
    }

    fnupdateUserbyId(Formvalues) {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'updateUserbyId';
                let requestParameters = Formvalues;               
                let result = await this.fnFormDataHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            })
        } catch (err) {
            console.log(err);
        }
    }

    fnsignupUser(value) {
        try {
            // let fd = new FormData();
            // fd.append('email',data)
            return new Promise(async (resolve, reject) => {
                
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'signup';
                let requestParameters = value;          
                let result = await this.fnHttpPostCall(targetUrl, postUrl,requestParameters);
                resolve(result);
            })
        } catch (err) {
            console.log(err);
        }
    }

    fnGetAllProductionPartnerUsers() {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getAllProductionPartnerUsers';
                let requestParameters = {};
                let result = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            })
        } catch (err) {
            console.log(err);
        }
    }

    fnGetAllPPCompnaies() {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getAllPPCompanies';
                let requestParameters = {};
                let result = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            })
        } catch (err) {
            console.log(err);
        }
    }

    fnGetAllCSDUsers() {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getAllCSDUsers';
                let requestParameters = {};
                let result = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            })
        } catch (err) {
            console.log(err);
        }
    }

    fnGetPrintMethodByName(pp_name) {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getPrintMethodByName';
                let requestParameters = { 'pp_name': pp_name };
                let result = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            })
        } catch (err) {
            console.log(err);
        }
    }

    fnGetAllDesignerPartnerUsers() {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getAllDesignerPartnerUsers';
                let requestParameters = {};
                let result = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            })
        } catch (err) {
            console.log(err);
        }
    }

    fnUpdateUsers() {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'update-users-profile-mysql';
                let requestParameters = {};
                let result = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            })
        } catch (err) {
            console.log(err);
        }
    }

    fnGetUserByEmail(user_email) {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getUserByEmail';
                let requestParameters = { 'email': user_email };
                let result = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            })
        } catch (err) {
            console.log(err);
        }
    }

    fnGetUserById(user_id) {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getUserById';
                let requestParameters = { 'user_id': user_id };
                let result = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            })
        } catch (err) {
            console.log(err);
        }
    }

    fnDeleteUser(user_id) {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'deleteUser';
                let requestParameters = { 'user_id': user_id };
                // let authKey = "access-token";
                let result = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            })
        } catch (err) {
            console.log(err);
        }
    }

    fnGetArtLocations() {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getArtLocations';
                let requestParameters = {};
                let result = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnGetArtworkPostionByLocation(artworkLocation) {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getArtworkPostionByLocation';
                let requestParameters = { 'artworkLocation': artworkLocation };
                let result = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnGetPrintMethods() {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getPrintMethods';
                let requestParameters = {};
                let result = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnAuthLoginAPI(email) {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'login';
                let requestParameters = { 'email': email };
                let result = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnAuthLogoutAPI(email) {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'logout';
                let requestParameters = { 'email': email };
                let result = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }

    async fnAuthLogin(email) {
        try {
            return new Promise(async (resolve, reject) => {
                let user: any = await this.fnAuthLoginAPI(email);
                if (user && user.access_token) {
                    this.fnSaveToken(user.access_token);
                    this.fnSaveUserPermissionLevel(user.permission_level);
                    this.fnSaveUser(user);
                    resolve(true);
                } else {
                    this.fnAuthLogOut(email);
                    resolve(false);
                }
            });
        } catch (e) {
            console.log(e);
        }
    }

    async fnAuthLogOut(email) {
        try {
            let user: any = await this.fnAuthLogoutAPI(email);
            if (user) {
                localStorage.removeItem(TOKEN_KEY);
                localStorage.removeItem(USER_PERMISSION_LEVEL);
                localStorage.removeItem(USER_KEY);
            }
        } catch (e) {
            console.log(e);
        }
    }

    // fnAuthLogOut(): void {
    //     localStorage.removeItem(TOKEN_KEY);
    //     localStorage.removeItem(USER_PERMISSION_LEVEL);
    //     localStorage.removeItem(USER_KEY);
    // }

    fnSaveToken(token: string): void {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.setItem(TOKEN_KEY, token);
    }

    fnSaveUserPermissionLevel(token: string): void {
        localStorage.removeItem(USER_PERMISSION_LEVEL);
        localStorage.setItem(USER_PERMISSION_LEVEL, token);
    }

    fnGetAuthToken(): string | null {
        return localStorage.getItem(TOKEN_KEY);
    }

    fnSaveUser(user: any): void {
        localStorage.removeItem(USER_KEY);
        localStorage.setItem(USER_KEY, JSON.stringify(user));
    }

    fnGetUser(): any {
        const user = localStorage.getItem(USER_KEY);
        if (user) {
            return JSON.parse(user);
        }
        return {};
    }

    fnGetProductionPricing(print_method_id, pp_company_id) {
        try {
            return new Promise(async (resolve, reject) => {
                let requestParameters = { 'pm_id': print_method_id, 'pp_company_id': pp_company_id };
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getProductionPricing';
                let productionPricing: any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(productionPricing);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnGetVinylPricing(print_method_id, ppCompanyId) {
        try {
            return new Promise(async (resolve, reject) => {
                let requestParameters = { 'pm_id': print_method_id, 'pp_company_id': ppCompanyId };
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getVinylPricing';
                let productionPricing: any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(productionPricing);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnSaveTables(ppCompanyId, activeTabId, result) {
        try {
            let data = {
                ppCompanyId: ppCompanyId,
                printMethodId: activeTabId,
                allPricingData: result
            }
            return new Promise(async (resolve, reject) => {
                let requestParameters = data;
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'saveProductionPricing';
                let response: any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(response);
            })
        } catch (e) {
            console.log(e);
        }
    }

    fnGetRushFees(pp_company_id) {
        try {
            return new Promise(async (resolve, reject) => {
                let requestParameters = { 'pp_company_id': pp_company_id };
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getRushFees';
                let productionPricing: any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(productionPricing);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnSaveRushFees(ppCompanyId, rushFeesData) {
        try {
            let data = {
                ppCompanyId: ppCompanyId,
                rushFeesData: rushFeesData
            }
            return new Promise(async (resolve, reject) => {
                let requestParameters = data;
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'saveRushFees';
                let response: any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(response);
            })
        } catch (e) {
            console.log(e);
        }
    }

    fnGetCategories() {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getCategories';
                let requestParameters = {};
                let result = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            })
        } catch (e) {
            console.log(e);
        }
    }

    fnGetSystemSettings() {
        try {
            return new Promise(async (resolve, reject) => {
                let requestParameters = {};
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getSystemSettings';
                let productionPricing: any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                let rObj = {};
                productionPricing.forEach(obj => {
                    rObj[obj.key] = obj.value;
                });
                resolve(rObj);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnGetprintLocation() {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getPrintLocation';
                let requestParameters = {};
                let result = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            })
        } catch (e) {
            console.log(e);
        }
    }

    fnSaveOrder(order) {
        try {
            return new Promise(async (resolve, reject) => {
                let isCompleted;
                if(sessionStorage.getItem('is_save_order_completed')){
                    // console.log('coming here',sessionStorage.getItem('is_save_order_completed'));
                    isCompleted = sessionStorage.getItem('is_save_order_completed');
                }
                else{
                    // console.log('coming here else',sessionStorage.getItem('is_save_order_completed'));
                    sessionStorage.setItem('is_save_order_completed','true');
                    isCompleted = 'true';
                }
                let allowOrderToSave = true;
                if (order.order_id != undefined || order.order_id > 0 ) {
                    let allowOrderToSaveStatus = await this.fnCheckAllowToSaveOrder(order.order_id);
                    if (!allowOrderToSaveStatus && isCompleted == 'true') {
                        if (sessionStorage.getItem("show_refresh_modal")) {
                            sessionStorage.removeItem('show_refresh_modal');
                        }
                        sessionStorage.setItem('show_refresh_modal', 'true');
                        sessionStorage.setItem('is_save_order_completed','true');
                        allowOrderToSave = false;
                    }
                }
                if (allowOrderToSave || isCompleted == 'false') {
                    sessionStorage.setItem('is_save_order_completed','false');
                    let requestParameters = { 'order': order };
                    let targetUrl = environment.config.proxy_url;
                    let postUrl = targetUrl + 'saveOrder';
                    // const requestParams = {
                    //     requestHeaders,
                    //     postUrl,
                    //     requestData
                    // }
                    // this.saveOrderCall.next(requestParams);
                    // this.saveOrderResponse.subscribe(async (result)=>{
                    //     if (result) {
                    //             // setTimeout(async () => {
                    //             //     await this.fnSetPageLoadedDateTime();
                    //             // }, 2000);
                    //             console.log('result',result);
                    //             console.log('coming here in subscribe');
                    //             await this.fnSetPageLoadedDateTime(true);
                    //             resolve(result);
                    //         } else {
                    //             resolve(false);
                    //         }
                    // })
                    if(this.saveOrder){
                        this.saveOrder.unsubscribe();
                    }
                    this.saveOrder = this.fnHttpPostCallWithObservable(targetUrl, postUrl, requestParameters).subscribe(
                        async (result)=>{
                            if (result) {
                                // setTimeout(async () => {
                                //     await this.fnSetPageLoadedDateTime();
                                // }, 2000);
                                await this.fnSetPageLoadedDateTime(true);
                                sessionStorage.setItem('is_save_order_completed','true');
                                resolve(result);
                            } else {
                                resolve(false);
                            }
                        }
                    )
                    // let result: any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                    // if (result) {
                    //     // setTimeout(async () => {
                    //     //     await this.fnSetPageLoadedDateTime();
                    //     // }, 2000);
                    //     await this.fnSetPageLoadedDateTime(true);
                    //     resolve(result);
                    // } else {
                    //     resolve(false);
                    // }
                } else {
                    resolve(false);
                }
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnGeneratePricingFunction(printMethodId, ppCompanyId) {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'generatePricingFunction';
                let requestParameters = { printMethodId, ppCompanyId };
                let result = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnGetOrder(order_id) {
        try {
            return new Promise(async (resolve, reject) => {
                let requestParameters = { 'order_id': order_id };
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getOrder';
                let result: any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnSavePricingFunction(printMethodId, userId, ppCompanyId, printFunctionData) {
        try {
            return new Promise(async (resolve, reject) => {
                let requestParameters = { printMethodId, userId, ppCompanyId, printFunctionData };
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'savePricingFunction';
                let response: any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnSaveVinylPricing(printMethodId, userId, ppCompanyId, vinylData) {
        try {
            return new Promise(async (resolve, reject) => {
                let requestParameters = { printMethodId, userId, ppCompanyId, vinylData };
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'saveVinylPricing';
                let response: any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnGetGarmentByUpmerchItem(upmerchItem) {
        try {
            return new Promise(async (resolve, reject) => {
                let requestParameters = {
                    'upmerchItem': upmerchItem,
                };
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getProductByUpMerchItem';
                let result: any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                if (result && result.length > 0) {
                    resolve(result[0]);
                } else {
                    resolve([]);
                }
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnGetOrdersByFilters(filters, recordsFrom) {
        try {
            return new Promise(async (resolve, reject) => {
                const requestParameters = {
                    filters, recordsFrom
                };
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getOrdersByFilters';
                let result: any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnGetOrdersTotalProfitRevenue(filters) {
        try {
            return new Promise(async (resolve, reject) => {
                let requestParameters = {
                    'filters' : filters
                };
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getOrdersTotalProfitRevenue';
                let result: any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnGetProductionOrdersTotalInvoice(filters) {
        try {
            return new Promise(async (resolve, reject) => {
                let requestParameters = {
                    'filters' : filters
                };
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getProductionOrdersTotalInvoice';
                let result: any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnGetSalesOrdersStatusCount(filters) {
        try {
            return new Promise(async (resolve, reject) => {
                let requestParameters = {
                    'filters' : filters
                };
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getSalesOrdersStatusCount';
                let result: any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnGetDesignOrdersStatusCount(filters) {
        try {
            return new Promise(async (resolve, reject) => {
                let requestParameters = {
                    'filters' : filters
                };
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getDesignOrdersStatusCount';
                let result: any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnGetProductionOrdersStatusCount(filters) {
        try {
            return new Promise(async (resolve, reject) => {
                let requestParameters = {
                    'filters' : filters
                };
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getProductionOrdersStatusCount';
                let result: any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnCancelOrder(order_id) {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'cancelOrder';
                let requestParameters = { 'order_id': order_id };
                let result = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            })
        } catch (err) {
            console.log(err);
        }
    }

    fnRequestFinalArtworkFile(orderId, flag) {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'requestFinalArtworkFile';
                let requestParameters = { 'order_id': orderId, 'flag': flag };
                let result = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnGetRDBMSServerCurrentDateTime() {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getRDBMSServerCurrentDateTime';
                let requestParameters = {};
                let result = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            })
        } catch (err) {
            console.log(err);
        }
    }

    fnCheckAllowToSaveOrder(order_id) {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                // const requestHeaders = this.fnFetchHttpRequesHeaders(targetUrl);
                let postUrl = targetUrl + 'checkAllowToSaveOrder';
                // let requestData = { 
                //     'order_id': order_id,
                //     'page_loaded_at' : sessionStorage.getItem('page_loaded_at')
                // };
                let requestParameters = { 
                    'order_id': order_id,
                    'page_loaded_at' : sessionStorage.getItem('page_loaded_at')
                };
                // const requestParams = {
                //     requestHeaders,
                //     postUrl,
                //     requestData
                // }
                // this.checkSaveOrderCall.next(requestParams);
                // let result = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                // resolve(result);
                if(this.checkSaveOrder)
                {
                    this.checkSaveOrder.unsubscribe();
                }
                this.checkSaveOrder = this.fnHttpPostCallWithObservable(targetUrl, postUrl, requestParameters).subscribe(
                    (res)=>{
                        // console.log('getting result',res);
                        resolve(res)
                    }
                )
                // this.checkSaveOrderResponse.subscribe((result)=>{
                //     console.log('should not keep coming here',result);
                //     resolve(result)
                // })
            })
        } catch (err) {
            console.log(err);
        }
    }

    fnGetCurrentAmericaChicagoDateTime() {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                const requestHeaders = this.fnFetchHttpRequesHeaders(targetUrl);
                let postUrl = targetUrl + 'getCurrentAmericaChicagoDateTime';
                let requestParameters = {};
                // const requestParams = {
                //     requestHeaders,
                //     postUrl,
                //     requestData
                // }
                // this.getCurrentDateTimeCall.next(requestParams);
                // this.getCurrentDateTimeResponse.subscribe((result:any)=>{
                //     if (result && result.currentDate)  {
                //         resolve(result.currentDate);
                //     } else {
                //         resolve('');
                //     }
                // })
                // let result:any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                if(this.getCurrentDateTime){
                    this.getCurrentDateTime.unsubscribe();
                }
                this.getCurrentDateTime = this.fnHttpPostCallWithObservable(targetUrl, postUrl, requestParameters).subscribe(
                    (result)=>{
                        if (result && result.currentDate)  {
                            resolve(result.currentDate);
                        } else {
                            resolve('');
                        }
                    }
                )
            })
        } catch (err) {
            console.log(err);
        }
    }

    async fnSetPageLoadedDateTime(afterSave = false) {
        try {
            let currentDateTime:any = await this.fnGetCurrentAmericaChicagoDateTime();
            if (afterSave) {
                currentDateTime = this.addSecondInDateTime(currentDateTime)
            }
            if (sessionStorage.getItem("page_loaded_at")) {
                sessionStorage.removeItem('page_loaded_at');
            }
            sessionStorage.setItem('page_loaded_at', currentDateTime);
        } catch (err) {
            console.log(err);
        }
    }

    addSecondInDateTime(currentDateTime): string {
        let d = new Date(currentDateTime)
        d.setSeconds ( d.getSeconds() + 1 )
        let month = d.getMonth() + 1;
        let dstr = d.getFullYear()+'-'+month+'-'+d.getDate()+' '+d.getHours()+':'+d.getMinutes()+':'+d.getSeconds();
        return dstr;
    }

    fnCheckAllowToSaveUser(user_id) {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'checkAllowToSaveUser';
                let requestParameters = { 
                    'user_id': user_id,
                    'page_loaded_at' : sessionStorage.getItem('page_loaded_at')
                };
                let result = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            })
        } catch (err) {
            console.log(err);
        }
    }
    
    fnGetUsersForChatNotification(orderId, senderId) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'getUsersForChatNotification';
                const requestData = {orderId, senderId};
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnCheckIfUserIsAllowedToBeNotifiedInApp(userId, notificationKey) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'checkIfUserIsAllowedToBeNotifiedForApp';
                const requestData = {userId, notificationKey};
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnGetUsersForNotificationByPermissionLevel(permissionLevel, notificationKey) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'getUsersByPermissionLevelAndNotificationAllowance';
                const requestData = {permissionLevel, notificationKey};
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnGetUsersByPermissionLevel(permissionLevel) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'getUsersByPermissionLevel';
                const requestData = {permissionLevel};
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnGetCSDUserFromSalesPartner(salesPartnerId) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'getCSDUserFromSalesPartner';
                const requestData = {salesPartnerId};
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnGetOrderJob(orderId) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'getOrderJob';
                const requestData = {orderId};
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnSendToPPNewOrderEmails(orderId) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'sendToPPNewOrderEmails';
                const requestData = {orderId};
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnSendEmailToSPuserForSendToProduction(order_id, email, SPid, key) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'sendEmailToSPuserForSendToProduction';
                const requestData = {order_id, email, SPid, key};
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnSendEmailToDPArtworkFileRequested(order_id, email, dpId, key) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'sendEmailToDPArtworkFileRequested';
                const requestData = {order_id, email, dpId, key};
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnLockUnlockOrderPricing(requestData) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'lockUnlockOrderPricing';
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnGetOrderPricingLockStatus(orderId) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'getOrderPricingLockStatus';
                const requestData = {orderId};
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnSendGreekLicensingApprovedEmail(userId, email, orderId) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'sendGreekLicensingApprovedEmail';
                const requestData = {userId, email, orderId};
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnSendGreekLicensingRejectedEmail(userId, email, orderId) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'sendGreekLicensingRejectedEmail';
                const requestData = {userId, email, orderId};
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnSendOrderShippedEmail(orderId, salesPartnerId, salesPartnerEmail) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'sendOrderShippedEmail';
                const requestData = {orderId, salesPartnerId, salesPartnerEmail};
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnSendComissionProcessedEmail(orderId, salesPartnerId, salesPartnerEmail) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'sendCommissionProcessedEmail';
                const requestData = {orderId, salesPartnerId, salesPartnerEmail};
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnSendPaymentPendingEmail(orderId, salesPartnerId, salesPartnerEmail) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                // const postUrl = targetUrl + 'sendCommissionProcessedEmail';
                const postUrl = targetUrl + 'sendPaymentPendingEmail';
                const requestData = {orderId, salesPartnerId, salesPartnerEmail};
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnSendPaymentReceivedEmail(orderId, salesPartnerId, salesPartnerEmail) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'sendPaymentReceivedEmail';
                const requestData = {orderId, salesPartnerId, salesPartnerEmail};
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnSendArtworkRejectedEmail(orderId, designPartnerId, designPartnerEmail) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'sendArtworkRejectedEmail';
                const requestData = {orderId, designPartnerId, designPartnerEmail};
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnSendArtworkCompleteEmail(orderId, designPartnerId, designPartnerEmail) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'sendArtworkCompleteEmail';
                const requestData = {orderId, designPartnerId, designPartnerEmail};
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnSendArtworkApprovalEmail(orderId, salesPartnerId, salesPartnerEmail) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'sendArtworkApprovalEmail';
                const requestData = {orderId, salesPartnerId, salesPartnerEmail};
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnSendStatusChangeEmail(orderId, salesPartnerId, salesPartnerEmail) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'sendStatusChangeEmail';
                const requestData = {orderId, salesPartnerId, salesPartnerEmail};
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnSendNewPPOrderEmail(orderId, productionPartnerId, productionPartnerEmail) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'sendNewPPOrderEmail';
                const requestData = {orderId, productionPartnerId, productionPartnerEmail};
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnSendInvoicePaidEmail(orderId, productionPartnerId, productionPartnerEmail) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'sendInvoicePaidEmail';
                const requestData = {orderId, productionPartnerId, productionPartnerEmail};
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnSaveReqDataInApiLogs(requestData) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'saveReqDataInApiLogs';
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnSaveResDataInApiLogs(requestData) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'saveResDataInApiLogs';
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    getNotificationOptionsByPermissionLevel(permissionLevel) {
        try {
            console.log(permissionLevel)
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getNotificationOptionsByPermissionLevel';
                let requestParameters = {"permission_level": permissionLevel};
                let result = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            })
        } catch (err) {
            console.log(err);
        }
    }


    async setStrUrlString(str) {
        if (!str.includes(' ')) {
          return str.toLowerCase();
        }
        await this.fnGetAllSearchTypesMasterData()
        let keywords = this.getKeywords(str);
        let keywordString = keywords.join('-')
        return keywordString;
    }

    fnGetAllSearchTypesMasterData() {
        try {
            return new Promise(async (resolve, reject) => {
                if (this.allSearchTypesMasters) {
                    resolve(true)
                    return true;
                }
                let allSearchTypesJson = localStorage.getItem('search_types');
                let allSearchTypes = []
                if (!allSearchTypesJson) {
                  let targetUrl = environment.config.proxy_url;
                  let postUrl = targetUrl + 'getSearchTypeMasters';
                  let requestParameters = [];
                  let searchTypesMasters = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                  allSearchTypes = [...searchTypesMasters['brands'], ...searchTypesMasters['categories'], ...searchTypesMasters['colors'], ...searchTypesMasters['sizes']];
                  localStorage.setItem('search_types', JSON.stringify(allSearchTypes));
                } else {
                  allSearchTypes = JSON.parse(allSearchTypesJson);
                }
                this.allSearchTypesMasters = allSearchTypes;
                console.log('fnGetAllSearchTypesMasterData ends')
                resolve(true);
            });
        } catch (e) {
            console.log(e);
        }
    }

    getKeywords(str) {
        if (!str.includes(' ')) {
          return str.toLowerCase();
        }
        let result = this.checkStringExist(str);
        if (result) {
          return [str.replace(/[\s]/g, '_').replace(/[\/]/g, '~').toLowerCase()];
        }
        let keywordsNum = (str.match(new RegExp(" ", "g")) || []).length + 1 
        if(keywordsNum > 2) {
          let tempStr = str;
          for (let i = 1; i < keywordsNum; i++){
            let index = tempStr.lastIndexOf(" ");
            let firstPsblKey = str.substring(0,index)
            let secondPsblKey = str.substring(index+1,str.length)
            let result = this.checkStringExist(firstPsblKey);
            if (result || i == keywordsNum -1) {
              let firstKey = [firstPsblKey.replace(/[\s]/g, '_').replace(/[\/]/g, '~').toLowerCase()]
              let secondKeys = this.getKeywords(secondPsblKey);
              return firstKey.concat(secondKeys);
            } 
            tempStr = firstPsblKey;
          }    
        } else {
          return str.split(' ').map((ele) => {return ele.toLowerCase()});
        }
    }

    checkStringExist(str): boolean {
        str = str.toLowerCase();
        return this.allSearchTypesMasters.includes(str)
    }

    fnGetChatsMessages(userId, order_id, chat_id, fromIndex) {
        try {
            return new Promise(async (resolve, reject) => {
                let requestParameters = { 'order_id': order_id, 'chat_id': chat_id, 'user_id': userId, fromIndex};
                console.log(requestParameters)
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getChatMessages';
                let result: any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }
    fnAddChatsMessages(data) {
        try {
            return new Promise(async (resolve, reject) => {
                let requestParameters = data;
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'addChatMessage';
                let result: any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }
    fnDeleteChatMessage(data) {
        try {
            return new Promise(async (resolve, reject) => {
                let requestParameters = data;
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'deleteChatMessage';
                let result: any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }
    fnEditChatMessage(data) {
        try {
            return new Promise(async (resolve, reject) => {
                let requestParameters = data;
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'editChatMessage';
                let result: any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }
    fnChangeUserMsgStatusToRead(data) {
        try {
            return new Promise(async (resolve, reject) => {
                let requestParameters = data;
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'changeUserMsgStatusToRead';
                let result: any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnFetchOrderChats(requestData) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'getChatThreads';
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnFetchSingleChatThread(requestData) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'getSingleChatThread';
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnDeleteChatMember(requestData) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'deleteChatMember';
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }
    
    fnAddChatMember(requestData) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'addChatMember';
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnGetProductionOrdersStatusesCount(requestData) {
        try {
            return new Promise(async (resolve, reject) => {
                // let requestParameters = data;
                let targetUrl = environment.config.proxy_url;
                const requestHeaders = this.fnFetchHttpRequesHeaders(targetUrl);
                let postUrl = targetUrl + 'getProductionOrdersStatusesCount';
                const requestParams = {
                    requestHeaders,
                    postUrl,
                    requestData
                }
                // let result: any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                this.searchCall.next(requestParams);
                this.searchResult.subscribe((responseData)=>{
                    // console.log('getting response',responseData);
                    resolve(responseData)
                },
                (error)=>{
                    console.log('getting error',error);
                })
                // resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnGetSalesOrdersStatusesCount(requestData) {
        try {
            return new Promise(async (resolve, reject) => {
                // let requestParameters = data;
                let targetUrl = environment.config.proxy_url;
                const requestHeaders = this.fnFetchHttpRequesHeaders(targetUrl);
                let postUrl = targetUrl + 'getSalesOrdersStatusesCount';
                const requestParams = {
                    requestHeaders,
                    postUrl,
                    requestData
                }
                // let result: any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                this.searchCall.next(requestParams);
                this.searchResult.subscribe((responseData)=>{
                    // console.log('getting response',responseData);
                    resolve(responseData)
                },
                (error)=>{
                    console.log('getting error',error);
                })
                // resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnSearchUsers(requestData) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const requestHeaders = this.fnFetchHttpRequesHeaders(targetUrl);
                const postUrl = targetUrl + 'searchUsers';
                const requestParams = {
                    requestHeaders,
                    postUrl,
                    requestData
                }
                // const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                this.searchCall.next(requestParams);
                this.searchResult.subscribe((responseData)=>{
                    // console.log('getting response',responseData);
                    resolve(responseData)
                },
                (error)=>{
                    console.log('getting error',error);
                })
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnSearchAdminCSDUsers(requestData) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const requestHeaders = this.fnFetchHttpRequesHeaders(targetUrl);
                const postUrl = targetUrl + 'searchAdminCSDUsers';
                const requestParams = {
                    requestHeaders,
                    postUrl,
                    requestData
                }
                // const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                this.searchAdminCSDUsersCall.next(requestParams);
                this.searchAdminCSDUsersResult.subscribe((responseData)=>{
                    // console.log('getting response',responseData);
                    resolve(responseData)
                },
                (error)=>{
                    console.log('getting error',error);
                })
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnSearchSPUsers(requestData) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const requestHeaders = this.fnFetchHttpRequesHeaders(targetUrl);
                const postUrl = targetUrl + 'searchSPUsers';
                const requestParams = {
                    requestHeaders,
                    postUrl,
                    requestData
                }
                // const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                this.searchSPUsersCall.next(requestParams);
                this.searchSPUsersResult.subscribe((responseData)=>{
                    // console.log('getting response',responseData);
                    resolve(responseData)
                },
                (error)=>{
                    console.log('getting error',error);
                })
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnFetchUnreadOrderChats(requestData) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'getUnreadThreads';
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnFetchUnreadMessagesCount(requestData) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'getUnreadMessagesCount';
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    getallHQUsers(requestData) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'getAllHQUsers';
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }
    
    getOrderProductsDetail(requestData) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'getOrderProductsDetail';
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    getOrderArtworkDetail(requestData) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'getOrderArtworkDetail';
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    getArtworkApprovalImages(requestData) {
        try {
            return new Promise(async (resolve, reject) => {
                const targetUrl = environment.config.proxy_url;
                const postUrl = targetUrl + 'getArtworkApprovalImages';
                const response = await this.fnHttpPostCall(targetUrl, postUrl, requestData);
                resolve(response);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnAddMemberToChat(data) {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'addMemberToChat';
                let result: any = await this.fnHttpPostCall(targetUrl, postUrl, data);
                resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnCheckIfOrderCancelled(data) {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'checkIfOrderCancelled';
                let result: any = await this.fnHttpPostCall(targetUrl, postUrl, data);
                resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnRejectArtwork(data) {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'rejectArtwork';
                let result: any = await this.fnHttpPostCall(targetUrl, postUrl, data);
                resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnMarkChatReadUnread(data) {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'markChatReadUnread';
                let result: any = await this.fnHttpPostCall(targetUrl, postUrl, data);
                resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnGetOrderShippingDetails(data) {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getOrderShippingDetail';
                let result: any = await this.fnHttpPostCall(targetUrl, postUrl, data);
                resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnGetAllSizes() {
        try {
            return new Promise(async (resolve, reject) => {
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getAllSizes';
                let result: any = await this.fnHttpPostCall(targetUrl, postUrl, null);
                resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnGetStatusesCount(data) {
        try {
            return new Promise(async (resolve, reject) => {
                let requestParameters = data;
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getStatusesCount';
                let result: any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(result);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnGetAllPrintMethod() {
        try {
            return new Promise(async (resolve, reject) => {
                let requestParameters = '';
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getAllPrintMethod';
                let method: any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(method);
            });
        } catch (e) {
            console.log(e);
        }
    }

    fnGetBankHolidays() {
        try {
            return new Promise(async (resolve, reject) => {
                let requestParameters = '';
                let targetUrl = environment.config.proxy_url;
                let postUrl = targetUrl + 'getBankHolidays';
                let method: any = await this.fnHttpPostCall(targetUrl, postUrl, requestParameters);
                resolve(method);
            });
        } catch (e) {
            console.log(e);
        }
    }

}
